module.exports = __webpack_public_path__ + "static/media/BobbyJones-Regular.8b2127b5.woff2";